
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  data() {
    return {
      jwtToket: null,
      env: window.config?.node_env,
    }
  },
  methods: {
    async $_getJWTToken() {
      await api.getYCToken()
        .then(async (jwtToket) => {
          this.jwtToket = jwtToket
          this.$nextTick(() => {
            this.$_sendToFrame({messageType: 'jwt', jwt: jwtToket})
          })
        })
    },
    $_sendToFrame(message) {
      try {
        this.$nextTick(() => {
          this.$refs.myIframe?.contentWindow?.postMessage(message, 'https://youcontrol.market')
        })
      } catch (_) {
        /*this.$notice.warning({
          title: this.$t('Common.ErrorTitle'),
          message: 'Помилка відправки JWT'
        })*/
      }
    },
    $_getUniqueEmails(props) {
      if (!props?.length) {
        return {
          props: props,
          emails: []
        }
      }

      const result = {
        props: props,
        emails: [],
        info: [],
      }
      const pushEmail = (email, element) => {
        if (!email) {
          return
        }
        if (!email.match(/^\s*([A-Za-z0-9_\-.'])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,10})\s*$/gm)) {
          return
        }
        if (result.emails.findIndex(i => i === email) === -1) {
          result.emails.push(email)
          element.email = email
          result.info.push({
            email: email,
            name: element.name,
            code: element.code
          })
        }
      }
      props.forEach(element => {
        if (element?.email) {
          pushEmail(element.email, element)
        } else {
          element?.contactsFromTenders?.forEach(contactsFromTender => {
            pushEmail(contactsFromTender.email, element)
          })
        }
      })
      return result
    },
    $_handleMessage(event) {
      if (!event.data) {
        return
      }
      if (event.origin === 'https://youcontrol.market') {
        switch (event.data.messageType) {
        case 'wait_for_jwt': {
          this.$_getJWTToken()
          break
        }
        case 'procurementsData': {
          this.tempProps = event.data.procurementsData
          this.checkResultYoucontrol(JSON.parse(event.data.procurementsData))
          break
        }
        default: {
          break
        }
        }
      }
    }
  },
  computed: {
    iframeHref() {
      return this.$i18n.locale === 'uk'
        ? 'https://youcontrol.market/app/ua/market-analysis-external/ukraine'
        : 'https://youcontrol.market/app/en/market-analysis-external/ukraine'
    }
  },
  mounted() {
    window.addEventListener('message', this.$_handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.$_handleMessage)
  }
}
